import { useState } from 'react'
import { getMutualFundDetailCTA } from '../../utils/mutualFundDetail'
import { lightImpactVibrate, postCTA } from '../../utils/appBridge'
import { copyToClipboard } from '../../utils/utils'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'

export const RedirectionTab = ({
  isPage = false,
  directFundISIN,
  directFundName,
  title = 'Direct Plan'
}: {
  isPage?: boolean
  directFundISIN: string
  directFundName: string
  title?: string
}) => {
  const [scale, setScale] = useState(1)

  if (!directFundISIN) return null
  console.log(directFundISIN, directFundName)
  return (
    <div
      onClick={() => {
        if (directFundISIN) {
          postCTA(JSON.stringify(getMutualFundDetailCTA({ isin: directFundISIN, navigationStyle: 'PUSH' })))
        }
      }}
      className={`pt-3 pb-[14px] pr-3 pl-4 bg-[#E6F2FF] border border-[#EBF2F2] rounded-lg flex justify-between gap-2 items-center text-[13px] w-full min-h-[67px] ${isPage ? 'animate-fade-150' : ''}`}
    >
      <div className='flex w-1 flex-1'>
        <div className='w-full flex flex-col gap-[2px]'>
          <div className='text-[#1470CC]'>{title}</div>
          <div className={`text-[#232323] text-[13px] font-[500] leading-[150%] truncate break-words`}>
            {directFundName}
          </div>
        </div>
      </div>
      <div className='flex items-center gap-2'>
        {false && (
          <div
            className='px-2'
            style={{
              transform: `scale(${scale})`,
              transition: 'transform 0.1s ease'
            }}
            onClick={(e) => {
              e?.stopPropagation()
              setScale(0.95)
              setTimeout(() => setScale(1), 100)
              lightImpactVibrate()
              copyToClipboard(directFundName)
            }}
          >
            <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/copy-icon.svg`} />
          </div>
        )}
        <div>
          <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/right-chevron.svg`} />
        </div>
      </div>
    </div>
  )
}
